<popup-c class="bs-enabled"
		 head="Resource Information" size="medium"
		 (closeCb)="closeCb.emit();">
	<div class="f-1-0 h100 w100 flxClmn" style="overflow: auto;">

		<table class="w-75 mx-3 simpleDataTable" style="table-layout: fixed; font-size: 14px;">
			<tr>
				<td style="width: 140px;"><b>Type: </b></td>
				<td>
					<span>{{resourceTypeLabel(resource.resource_type)}}</span>
				</td>
			</tr>
			<tr *ngIf="resource.resource_sub_type">
				<td><b>Sub Type: </b></td>
				<td>
					<span>{{_.capitalize(resourceTypeLabel(resource.resource_sub_type))}}</span>
				</td>
			</tr>
			<tr *ngIf="resource.name">
				<td><b>Name: </b></td>
				<td>
					<span>{{resource.name}}</span>
				</td>
			</tr>
			<tr *ngIf="resource.id">
				<td><b>Resource ID: </b></td>
				<td>
					<span style="word-break: break-all;">{{resource.id}}</span>
				</td>
			</tr>
			<tr *ngIf="resource.last_updated">
				<td><b>Last Activity: </b></td>
				<td>
					<span>{{resource.last_updated | date:"MM/dd/yyyy HH:mm"}}</span>
				</td>
			</tr>
			<tr *ngIf="resource.members?.length">
				<td style="vertical-align: top;"><b>Members ({{resource.members.length}}): </b></td>
				<td>
					<span>{{resource.members.join(', ')}}</span>
				</td>
			</tr>
			<tr *ngIf="resource.external_members?.length">
				<td style="vertical-align: top;"><b>External ({{resource.external_members.length}}): </b></td>
				<td>
					<span>{{resource.external_members.join(', ')}}</span>
				</td>
			</tr>
		</table>

	</div>
</popup-c>
